import { render, staticRenderFns } from "./ShoppingCartSummary.vue?vue&type=template&id=2e971007&scoped=true&"
import script from "./ShoppingCartSummary.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e971007",
  null
  
)

export default component.exports